export default "__VITE_ASSET__U$5WbtiZ__"